module.exports = __webpack_public_path__ + "static/media/KV085.e956783a.jpg";